import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';
import { switchMap, takeWhile } from 'rxjs/operators';
import { UserSubscriptionService } from 'src/app/services/user-subscription.service';

export type PaymentStatus = 'LOADING' | 'SUCCESS' | 'PENDING' | 'CANCELLED' | 'ERROR';

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.scss'
})
export class PaymentComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private userSubscriptionService = inject(UserSubscriptionService);

  status: PaymentStatus = 'LOADING';
  sessionId: string | null = null;
  private pollSubscription?: Subscription;

  ngOnInit(): void {
    const isSuccessRoute = this.router.url.includes('/payment/success');
    console.log('1');
    if (isSuccessRoute) {
    console.log('2');
      this.sessionId = this.route.snapshot.queryParamMap.get('session_id');
      this.verifyPayment();
    } else {
    console.log('3');
      this.status = 'CANCELLED';
    }
  }

  /**
   * Polls the backend to verify if the subscription status has been updated to ACTIVE by the Stripe webhook.
   */
  private verifyPayment(): void {
    let attempts = 0;
    const maxAttempts = 5;

    this.pollSubscription = interval(1500)
      .pipe(
        switchMap(() => this.userSubscriptionService.getUserSubscription()),
        takeWhile((userSub) => {
          attempts++;
          console.log('attempts', attempts);
          const isActive = userSub?.status === 'ACTIVE';
          return !isActive && attempts < maxAttempts;
        }, true)
      )
      .subscribe({  
        next: (userSub) => {
          if (userSub?.status === 'ACTIVE') {
            this.status = 'SUCCESS';
          } else if (attempts >= maxAttempts) {
            this.status = 'PENDING';
          }
        },
        error: () => {
          this.status = 'ERROR';
        }
      });
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  goToAccount(): void {
    this.router.navigate(['/account?tab=subscription']);
  }

  ngOnDestroy(): void {
    this.pollSubscription?.unsubscribe();
  }
}